export default "__VITE_ASSET__DgUdyHsQ__"